import { ReactivesearchResultProps, StatsProps, useSearch } from "@usereactify/search";
import React from "react";

type Props = React.ComponentProps<NonNullable<StatsProps["render"]>>;

export const ShowAll: React.FC<Props> = (props) => {
  const { submitSearchTerm, searchTerm } = useSearch();

  return searchTerm?.length ? (
    <button className="btn view-all-results" onClick={() => submitSearchTerm(searchTerm)}>
      View All {props.resultStats.numberOfResults} Products
    </button>
  ) : null;
};
